export default __webpack_public_path__ + "static/media/microPhoneIcon.e94b32ec.svg";